const styles = {
  root: {
    paddingBottom: 40,
  },
  packageBox: {
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.04)',
    borderRadius: 8,
    overflow: 'hidden',
    '& .regular': { height: 8, background: '#004C3B' },
    '& .premium': { height: 8, background: '#2B7486' },
    '& .detail-container': {
      padding: 16,
      background: '#fff',
      borderRadius: 8,
      position: 'relative',
      top: -4,
    },
  },
};

export default styles;
